import React from 'react';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

const Container = styled.div`
  margin-top: 30px;
  font-size: 14px;
  color: #616161;
  letter-spacing: 0;
  line-height: 24px;
`;

const Content = ({conteudo}) => {
  return (
    <Container>
      { RichText.render(conteudo) }
    </Container>
  );
}

export default Content;
